module.exports = __webpack_public_path__ + "img/CARAC3.766e8bac.jpg";